import {Component, EventEmitter, Input, Output, inject} from '@angular/core';
import {DialogModule} from "@syncfusion/ej2-angular-popups";
import {FormInputComponent} from "../../../shared/elements/form-input/form-input.component";
import {HeadlineComponent} from "../../../shared/elements/headline/headline.component";
import {TooltipComponent} from "../../../shared/elements/tooltip/tooltip.component";
import {TranslatePipe} from "../../../shared/pipes/translate.pipe";
import {DialogService} from "../../../shared/services/dialog.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {FormUserGroupMailComponent} from "../../../shared/elements/form-user-group-mail/form-user-group-mail.component";
import {CalendarEventResource} from '../../../shared/types/calendar-types/calendarEventResource';

@Component({
    selector: 'app-dialog-calendar-participants',
    imports: [
        DialogModule,
        FormInputComponent,
        HeadlineComponent,
        TooltipComponent,
        TranslatePipe,
        FormUserGroupMailComponent
    ],
    template: `
  <ejs-dialog
    target=".dialogs" 
    class="simple-dialog" 
    [visible]='visible' 
    [animationSettings]='dialogService.getAnimationSettings()' 
    [resizeHandles]='dialogService.getResizeHandleDirection()' 
    [position]='dialogService.getPosition()' 
    [isModal]="true" 
    [allowDragging]="false" 
    [width]="'40%'" 
    [height]="'60vh'" 
    [zIndex]="999" 
    [showCloseIcon]="true" 
    (close)="visibleChange.emit(false)"
  >
    <ng-template #header>
      <div class="d-flex align-items-center justify-content-center">
        <app-headline [title]="('CALPARTICIPANTS' | translate)" [type]="'h5'" [class]="'text-primary'">
        </app-headline>
        <app-tooltip 
          [icon]="'help'" 
          [iconClass]="'fs-5 p-1'" 
          [text]="('CALPARTICIPANTSHELP' | translate)" 
          [width]="'300px'" 
          [height]="'100px'" 
          [cssClass]="'helpTooltip p-2'" 
          [opensOn]="'Click'">
        </app-tooltip>
      </div>
    </ng-template>
    <ng-template #content>
      <div class="d-flex flex-column h-100 p-3">
        <app-form-input 
          [type]="'search'" 
          [placeholder]="('SEARCHFORPARTICIPANT' | translate)" 
          [iconFront]="'search'" 
          [iconBack]="'close'" 
          [iconClickType]="'back'" 
          [fCN]="'searchString'" 
          [fG]="calendarParticipantsForm">
        </app-form-input>
        <app-headline [title]="('CALNOPARTICIPANTSFOUND' | translate)" [type]="'h6'" [class]="'text-center text-secondary mb-3'">
        </app-headline>

        <!-- Scrollable content-->
        <div class="custom-scrollbar overflow-y-auto h-100">
          <app-form-user-group-mail 
            [readonly]="true" 
            [allowEmails]="true" 
            [(user)]="calenderEvent.participants.user_ids" 
            [(groups)]="calenderEvent.participants.group_ids">
          </app-form-user-group-mail>
        </div>
      </div>
    </ng-template>
  </ejs-dialog>
  `
})
export class DialogCalendarParticipantsComponent {
  public dialogService: DialogService = inject(DialogService);
  private formBuilder: FormBuilder = inject(FormBuilder);

  @Input() public calenderEvent: CalendarEventResource = {} as CalendarEventResource;
  @Input() public visible: boolean = false;
  @Output() public  visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public calendarParticipantsForm: FormGroup = this.formBuilder.group({
    searchString: [''],
  });
}
